import React from 'react'
import Form from '../Form'
import './style.scss'

const ContactArea = ({ className }) => {

    const googleMapsUrl =
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3732.204186277985!2d-103.36558541893542!3d20.701931531533468!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8428ae284f82891f%3A0x458b7fb8c3d2158!2sC.%20Nicol%C3%A1s%20Romero%201555%2C%20Ni%C3%B1os%20Heroes%2C%2044260%20Guadalajara%2C%20Jal.!5e0!3m2!1sen!2smx!4v1769107002341!5m2!1sen!2smx';

    return (
        <div className={className}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-5 col-12">
                        <div className="contactInfo">
                            <span>IMSSPIRA</span>
                            <h2>
                                <span className="small-text"> | Ubicación Oficinas Guadalajara</span>
                            </h2>

                            <h6>Calle Nicolás Romero 1555, Niños Heroes, 44260 Guadalajara, Jal.</h6>
                            <iframe
                                title="Ubicación IMSSPIRA"
                                src={googleMapsUrl}
                                width="100%"
                                height="250"
                                style={{border: 0, marginTop: '15px'}}
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            />

                        </div>
                    </div>
                    <div className="col-12 col-lg-7">
                        <Form/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactArea
